import { INavbarItem } from '../interfaces/INavbarItems';

export const NAVBAR_LINK_DESKTOP: INavbarItem[] = [
  {
    label: 'Professionals',
    children: [
      {
        label: 'INDUSTRIES',
        children: [
          {
            label: 'Exterior contractors',
            to: `/exterior-contractors/`,
          },
          {
            label: 'Insurance',
            to: `/insurance/`,
          },
          {
            label: 'Restoration',
            to: `/restoration/`,
          },
          {
            label: 'Architects',
            to: `/architects/`,
          },
        ],
      },
      {
        label: 'INFORMATION',
        children: [
          {
            label: 'Tips and tricks',
            to: `/blog/?from=tips`,
          },
        ],
      },
    ],
  },
  {
    label: 'Homeowners',
    children: [
      {
        label: 'I WAS INVITED TO USE HOVER',
        children: [
          {
            label: 'By my contractor',
            to: `/invited-by-contractor/`,
          },
          {
            label: 'By my insurance company',
            to: `/invited-by-insurance/`,
          },
        ],
      },
      {
        label: 'I WANT TO KNOW HOW IT WORKS',
        children: [
          {
            label: 'How it works',
            to: `/how-it-works/`,
          },
        ],
      },
    ],
  },
  {
    label: 'Pricing',
    to: `/pricing/`,
  },
  {
    label: 'About',
    children: [
      {
        label: 'COMPANY',
        children: [
          {
            label: 'About us',
            to: `/about/`,
          },
          {
            label: 'Press',
            to: `/press/`,
          },
          {
            label: 'Blog',
            to: `/blog/`,
          },
          {
            label: 'Careers',
            to: `/careers/`,
          },
        ],
      },
      {
        label: 'LEGAL',
        children: [
          {
            label: 'Privacy policy',
            to: `/privacy/`,
          },
          {
            label: 'Terms of use',
            to: `/terms-of-use/`,
          },
        ],
      },
    ],
  },
];

export const NAVBAR_LINK_MOBILE: INavbarItem[] = [
  {
    label: 'Sign up',
    to: `/signup/`,
  },
  {
    label: 'Log in',
    to: `/login/`,
  },
  {
    label: 'Professionals',
    children: [
      {
        label: 'INDUSTRIES',
        children: [
          {
            label: 'Exterior contractors',
            to: `/exterior-contractors/`,
          },
          {
            label: 'Insurance',
            to: `/insurance/`,
          },
          {
            label: 'Restoration',
            to: `/restoration/`,
          },
          {
            label: 'Architects',
            to: `/architects/`,
          },
        ],
      },
      {
        label: 'INFORMATION',
        children: [
          {
            label: 'Tips and tricks',
            to: `/blog/?from=tips`,
          },
        ],
      },
    ],
  },
  {
    label: 'Homeowners',
    children: [
      {
        label: 'I WAS INVITED TO USE HOVER',
        children: [
          {
            label: 'By my contractor',
            to: `/invited-by-contractor/`,
          },
          {
            label: 'By my insurance company',
            to: `/invited-by-insurance/`,
          },
        ],
      },
      {
        label: 'I WANT TO KNOW HOW IT WORKS',
        children: [
          {
            label: 'How it works',
            to: `/how-it-works/`,
          },
        ],
      },
    ],
  },
  {
    label: 'Pricing',
    to: `/pricing/`,
  },
  {
    label: 'About',
    children: [
      {
        label: 'COMPANY',
        children: [
          {
            label: 'About us',
            to: `/about/`,
          },
          {
            label: 'Press',
            to: `/press/`,
          },
          {
            label: 'Blog',
            to: `/blog/`,
          },
          {
            label: 'Careers',
            to: `/careers/`,
          },
        ],
      },
      {
        label: 'LEGAL',
        children: [
          {
            label: 'Privacy policy',
            to: `/privacy/`,
          },
          {
            label: 'Terms of use',
            to: `/terms-of-use/`,
          },
        ],
      },
    ],
  },
];
